<template>
  <!-- <baidu-map class="bm-view" ak="fOzDOC3VKopilzyN4naVoQKuXAIrCqug" :center="center" :zoom="zoom" @ready="handler" :scroll-wheel-zoom="true"> -->
  <baidu-map class="bm-view" ak="fOzDOC3VKopilzyN4naVoQKuXAIrCqug" :center="{lng: 116.257, lat: 39.874}" :zoom="15" :scroll-wheel-zoom="true">
    <bm-scale anchor="BMAP_ANCHOR_TOP_LEFT"></bm-scale>
    <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_LEFT" ></bm-navigation>
    <bm-marker :position="{lng: 116.257, lat: 39.874}" @click="infoWindowOpen"></bm-marker>
    <bm-info-window :position="{lng: 116.257, lat: 39.8745}" title="恒安卫士 北京研发中心" :show="infoWindow.show"  @close="infoWindowClose" @open="infoWindowOpen">
      <p>地址：北京市丰台区大瓦窑北路1号院-3号楼</p>
      <p>电话：010-83738811</p>
    </bm-info-window>
  </baidu-map>
</template>
<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow'
import BmMarker from 'vue-baidu-map/components/overlays/Marker'
import BmScale from 'vue-baidu-map/components/controls/Scale'
import BmNavigation from 'vue-baidu-map/components/controls/Navigation'
export default {
  name: 'Bmap',
  data () {
    return {
      infoWindow: {show: true}
      // center: {lng: 0, lat: 0},
      // zoom: 3
    }
  },
  components: {
    BaiduMap,
    BmInfoWindow,
    BmMarker,
    BmScale,
    BmNavigation
  },
  mounted () {
  },
  methods: {
    infoWindowClose (e) {
      this.infoWindow.show = false
    },
    infoWindowOpen (e) {
      this.infoWindow.show = true
    },
    handler ({BMap, map}) {
      console.log(BMap, map)
      this.center.lng = 116.257
      this.center.lat = 39.874
      this.zoom = 12
    }
  }
}
</script>
<style>
.bm-view {
  width: 100%;
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/lib/Bmap.vue